import React from "react";
import { connect } from "react-redux";
import { Popup, Button, Switch } from "devextreme-react";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { openCloseModalDesactivarCupo, openCloseModalEditarCupo, doUpdateCupo } from "./action";

class ModalDesactivar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      switch: false,
    };
  }
  componentDidUpdate = (prevProps) => {
    if (this.props.isOpenModalDesactivar && !prevProps.isOpenModalDesactivar) {
      this.setState({ switch: false });
    }
  }
  handleCancel = () => {
    this.props.dispatch(openCloseModalEditarCupo(false, {}, false));
    this.props.dispatch(openCloseModalDesactivarCupo(false, {}, false));
  }
  handleDesactivar = () => {
    this.props.dispatch(doUpdateCupo(this.props.cupo));
  }
  handleSwitch = () => {
    this.setState((prevState) => ({ switch: !prevState.switch }));
  }

  render() {
    return (
      <Popup
        title="Desactivar cupo"
        showCloseButton
        dragEnabled={false}
        onHiding={this.handleCancel}
        visible={this.props.isOpenModalDesactivar}
        width={600}
        height={300}
        contentComponent={() => (
          <div className="modal-delete-mantenedor">
            {this.props.isLoading && <LoadingOverlay />}
            <span>
              ¿Está seguro de
              <span className="red-text bold"> desactivar </span> el cupo
              <span className="red-text bold"> {this.props.cupo.Nombre} </span>
              ?
            </span>
            <br />
            <br />
            <span>
              Esto implica remover todos los cupos agendados y en proceso de agendamiento a
              esta prestación para ser gestionadas por el Call Center y los solicitantes.
            </span>
            <br />
            <br />
            <div>
              <span>Desactivar cupo  </span>
              <Switch
                switchedOffText="No"
                switchedOnText="Si"
                value={this.state.switch}
                onValueChanged={this.handleSwitch}
              />
            </div>
            <div className="button-row">
              <div>
                <Button text="Cancelar" style={{ marginRight: 5 }} onClick={this.handleCancel} />
              </div>
              <div>
                <Button disabled={!this.state.switch} text="Desactivar" type="danger" onClick={this.handleDesactivar} useSubmitBehavior />
              </div>
            </div>
          </div >
        )
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isOpenModalEliminar: state.mantenedorCupos.isOpenModalEliminar,
  isOpenModalDesactivar: state.mantenedorCupos.isOpenModalDesactivar,
  cupo: state.mantenedorCupos.cupo,
  isLoading: state.mantenedorCupos.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalDesactivar);
